import { LinkOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

import { useEffect, useState } from 'react';

import { type DocumentType, graphql } from '@/gql';
import { env } from '@/env';

const COPY_LINK_TO_FILE_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment copyLinkToFileMenuitemFileFields on File {
    _id
    folder
    url
    parent {
      _id
    }
  }
`);

interface Props {
  file: DocumentType<typeof COPY_LINK_TO_FILE_MENU_ITEM_FILE_FRAGMENT>;
  onClose: () => void;
}

export const CopyLinkToFileMenuItem = ({ file, onClose }: Props) => {
  const { _id: fileId, folder, url, parent } = file;
  const [windowLocation, setWindowLocation] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWindowLocation(window.location.href);
    }
  }, []);

  return (
    <MenuItem
      onClick={() => {
        try {
          if (url) {
            navigator.clipboard.writeText(url);
          } else {
            const currentUrlWithoutFileId = parent?._id
              ? windowLocation.substring(0, windowLocation.lastIndexOf('/'))
              : windowLocation;

            const clipboardUrl = folder
              ? `${currentUrlWithoutFileId}/${fileId}`
              : `${env.NEXT_PUBLIC_APP_URL}/document/${fileId}/view`;

            navigator.clipboard.writeText(clipboardUrl);
          }

          enqueueSnackbar('Copied!');
        } catch (err) {
          if (!(err instanceof Error)) throw err;

          enqueueSnackbar(
            `There was an error copying the link - ${err.message}`,
            {
              variant: 'error',
            },
          );
          console.error(err);
        }
        onClose();
      }}
    >
      <ListItemIcon>
        <LinkOutlined />
      </ListItemIcon>
      <ListItemText primary="Copy link to clipboard" />
    </MenuItem>
  );
};
